export default __webpack_public_path__ + "static/media/GoogleCalendar.5951cb39.png";